import React, { useEffect } from "react";
import Navbar from "../../Shared/Navbar/Navbar";
import Aos from "aos";
import Footer from "../../Shared/Footer/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import "./About.css";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);
  return (
    <div className="container">
      <section>
        <Navbar></Navbar>
      </section>
      <section data-aos="zoom-out-down" className="pt-53 text-white">
        <h1>About me</h1>
        <hr />
        <h4 className="pt-4">WHO AM I</h4>
        <p className="pt-3 lh-base text">
          I'm Md. Raisul Islam. I am MERN Stack Developer. To obtain a
          challenging position in a high-quality software engineering circle and
          to build up a successful career in a dynamic and professional
          environment of any reputable company or institution through aptitude,
          hard work, dedication and determination. My Skills Set: Javascript,
          React, Redux, ES6, React Hook, React Native, Node Js, Express Js,
          MongoDB, Bootstrap, Flexbox, SASS, CSS Grid, CSS, HTML.
        </p>
      </section>
      <section className="row pt-5 text-white">
        <div data-aos="zoom-out-right" className="col-md-4">
          <strong>Birthday:</strong> 20 May, 1998
          <hr />
          <strong>Degree:</strong> B.Sc
          <hr />
          <strong>City:</strong> Patuakhali, Barishal, Bangladesh
          <hr />
        </div>
        <div data-aos="zoom-out-up" className="col-md-4">
          <strong>Age:</strong> 25
          <hr />
          <strong>Email:</strong> raisulislam.cse3.bu@gmail.com
          <hr />
          <strong>Phone:</strong> +88 01718556127
          <hr />
        </div>
        <div data-aos="zoom-out-left" className="col-md-4">
          <strong>React</strong>
          <div class="progress">
            <div
              class="progress-bar bg-danger"
              role="progressbar"
              style={{ width: "85%" }}
              aria-valuenow="85"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              85%
            </div>
          </div>
          <br />
          <strong>Javascript</strong>
          <div class="progress">
            <div
              class="progress-bar bg-danger"
              role="progressbar"
              style={{ width: "90%" }}
              aria-valuenow="90"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
          <br />
          <strong>Node Js</strong>
          <div class="progress">
            <div
              class="progress-bar bg-danger"
              role="progressbar"
              style={{ width: "70%" }}
              aria-valuenow="70"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              70%
            </div>
          </div>
          <br />
          <strong>MongoDB</strong>
          <div class="progress">
            <div
              class="progress-bar bg-danger"
              role="progressbar"
              style={{ width: "90%" }}
              aria-valuenow="90"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
      </section>
      <section className="col pt-5">
        <h4 className="pb-3  text-white">Education</h4>
        <div data-aos="zoom-out-up" className="education col-12 col-md-6">
          <h6>
            <FontAwesomeIcon icon={faBriefcase} /> January 2016 - February 2022
          </h6>
          <h5>
            <strong>B.Sc In CSE</strong>
          </h5>
          <h6>
            Department of Computer Science and Engineering, University of
            Barishal
          </h6>
        </div>
      </section>
      <div className="pt-5">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default About;
